import React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
// redux
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../redux/store";

// my imports
import useStyles from "../styles";
import FilesList from "./FilesList";
import {
  setXPSFiles,
  setFilesList,
  toggleIsLogScale,
  setIsSingleFile,
} from "../redux/App.store";
import { Divider, FormControlLabel, Link, Switch } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import {
  tooltip_download_example,
  tooltip_download_results,
  tooltip_select_xps,
  tooltip_toggle_log,
} from "../tooltips";
import * as controller from "../controller";

const MainTabView = () => {
  const classes = useStyles();

  const isLogScale = useSelector((state: RootState) => state.app.isLogScale);
  const showZip = useSelector((state: RootState) => state.app.showZip);
  const isComputing = useSelector((state: RootState) => state.app.isComputing);
  const blobHref = useSelector((state: RootState) => state.app.blobHref);
  const xpsfiles = useSelector((state: RootState) => state.app.xpsfiles);
  const downloadName = useSelector(
    (state: RootState) => state.app.downloadName
  );

  const dispatch = useDispatch();

  // Create a reference to the hidden file input element
  const hiddenFileInput = React.useRef<HTMLInputElement>(null);

  //functions

  const handleSetXPSFiles = () => {
    if (hiddenFileInput) {
      if (hiddenFileInput.current) hiddenFileInput!.current.click();
    }
  };

  // effects
  React.useEffect(() => {
    dispatch(setIsSingleFile(xpsfiles.length === 1));
  }, [xpsfiles, dispatch]);

  return (
    <>
      {/* <InputSetOpen textLabel="Arquivo(s) XPS" /> */}
      <Grid container spacing={2}>
        <Grid item container>
          <Grid item xs={12}>
            <input
              type="file"
              ref={hiddenFileInput}
              accept=".xps,.XPS"
              multiple
              onChange={(e) => {
                if (e.target.files) {
                  let fs: string[] = [];
                  let ff: Array<File> = [];
                  Array.from(e.target.files).forEach(function (item) {
                    fs.push(item.name);
                    ff.push(item);
                  });
                  dispatch(setXPSFiles(fs));
                  dispatch(setFilesList(ff));
                  e.target.value = "";
                }
              }}
              style={{ display: "none" }}
            ></input>
          </Grid>
          <Grid item container xs={12}>
            <Grid item xs={4}>
              <Typography variant="h6">Arquivo(s) XPS</Typography>
            </Grid>
            <Grid item xs={4}>
              <Tooltip title={tooltip_download_example}>
                <Button
                  color="secondary"
                  onClick={() => {
                    controller
                      .downloadInputExample()
                      .catch((e) => console.log(e));
                  }}
                  disabled={isComputing}
                >
                  Exemplo de XPS
                </Button>
              </Tooltip>
            </Grid>
            <Grid item container xs={4} justify="flex-end">
              <Grid item>
                <Tooltip title={tooltip_select_xps}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSetXPSFiles}
                    disabled={isComputing}
                  >
                    Selecionar
                  </Button>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item container xs={12} style={{ paddingTop: "20px" }}>
          <FilesList />
        </Grid>
        <Grid container className={classes.divider}>
          <Grid item xs={12}>
            <Divider />
          </Grid>
        </Grid>
        <Grid item container xs={12} justify="center">
          <Grid item>
            <Tooltip title={tooltip_toggle_log}>
              <FormControlLabel
                control={<Switch name="checked_log" />}
                color="primary"
                checked={isLogScale}
                disabled={isComputing}
                onChange={() => {
                  dispatch(toggleIsLogScale());
                }}
                label="Gráficos em escala logarítmica"
              />
            </Tooltip>
          </Grid>
        </Grid>
        {showZip && (
          <Grid item container xs={12} justify="center">
            <Grid item container className={classes.divider}>
              <Grid item xs={12}>
                <Divider />
              </Grid>
            </Grid>
            <Grid
              item
              container
              xs={12}
              justify="center"
              className={classes.resultsContainer}
            >
              <Grid item>
                <Typography variant="h5" color="textPrimary">
                  Resultados:
                </Typography>
              </Grid>
            </Grid>

            <Grid item container xs={12} justify="center" spacing={3}>
              <Grid item>
                <Paper
                  elevation={2}
                  style={{
                    padding: 15,
                    border: "1.21px solid black",
                    backgroundColor: "#ad1048",
                  }}
                >
                  <Tooltip title={tooltip_download_results}>
                    <Typography variant="h5" color="primary">
                      <Link
                        href={blobHref}
                        download={downloadName}
                        color="textPrimary"
                      >
                        {downloadName}
                      </Link>
                    </Typography>
                  </Tooltip>
                </Paper>
              </Grid>
              <Grid item container xs={12} justify="center">
                <Grid item>
                  <Typography
                    variant="body1"
                    style={{ justifyContent: "center" }}
                    color="textSecondary"
                  >
                    (clique para baixar)
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default MainTabView;
